/* !
 * jQuery facilities v1.0.0
 * Copyright 2023, Connecty Inc.
 */
(function ($, FUNCTIONS) {
	const a = 'is-active';
	const v = 'is-visible';
	const l = 'is-loading';
	const PATH = '/donation/interview-facilities/';
	const TITLE = '日本骨髄バンク | ドナー登録している方へ | 検査・面談ができる病院';

	let keyword = '', prefectures = 'すべて';
	if (location.search) {
		const searchArr = FUNCTIONS.getQuery();
		for (let i = 0; i < searchArr.length; i++) {
			if (searchArr[i] === 'p_keyword') {
				keyword = decodeURIComponent(searchArr.p_keyword);
			}
			if (searchArr[i] === 'p_prefectures') {
				prefectures = decodeURIComponent(searchArr.p_prefectures);
			}
		}
	}

	// CSV取得
	const csvToArray = (strData) => {
		const strDelimiter = ',';
		const objPattern = new RegExp(
			(
				'(\\' + strDelimiter + '|\\r?\\n|\\r|^)' +
				'(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|' +
				'([^\"\\' + strDelimiter + '\\r\\n]*))'
			),
			'gi'
		);
		let arrData = [[]];
		let arrMatches = null;
		let strMatchedValue;
		while ((arrMatches = objPattern.exec(strData)) !== null) {
			let strMatchedDelimiter = arrMatches[1];
			if (strMatchedDelimiter.length && (strMatchedDelimiter !== strDelimiter)) {
				arrData.push([]);
			}
			if (arrMatches[2]) {
				strMatchedValue = arrMatches[2].replace(new RegExp('\"\"', 'g'), '\"');
			} else {
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}

		let items = arrData[0];
		let jsonArr = [];
		for (let i = 1; i < arrData.length; i++) {
			if (arrData[i].length) {
				let a_line = {};
				let csvArrayD = arrData[i];
				for (let j = 0; j < items.length; j++) {
					a_line[items[j]] = csvArrayD[j];
				}
				jsonArr.push(a_line);
			}
		}
		return (jsonArr);
	};

	// 都道府県コード順に並べ替える
	const sortListByPref = (_json) => {
		const PREFCODES = [
			'北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県',
			'栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県',
			'石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県',
			'滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県',
			'岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県',
			'佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
		];
		let newArr = [];
		for (let i = 0; i < PREFCODES.length; i++) {
			for (let j = 0; j < _json.length; j++) {
				if (_json[j].prefecture === PREFCODES[i]) {
					newArr.push(_json[j]);
				}
			}
		}
		return newArr;
	};

	let csvData = new XMLHttpRequest();
	csvData.open('get', '/donation/interview-facilities/items.csv', true);
	csvData.send(null);
	csvData.onload = () => {
		let json = csvToArray(csvData.responseText);
		json = sortListByPref(json);

		Vue.createApp({
			data() {
				return {
					jsonData: json,
					keyword: keyword,
					pref: prefectures
				}
			},
			methods: {
				searchKeyword() {
					this.pref = 'すべて';
					this.keyword = $('#keyword').val();
				},
				searchPref() {
					this.keyword = '';
					$('#selectPref').removeClass(a);
				}
			},
			computed: {
				filterItems() {
					let items = this.jsonData;
					let itemsTemp = [];

					// キーワード検索
					if (this.keyword) {
						for (let i = 0; i < items.length; i++) {
							if (items[i].facility.indexOf(this.keyword) !== -1 ||
								items[i].prefecture.indexOf(this.keyword) !== -1 ||
								items[i].address.indexOf(this.keyword) !== -1) {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;

					// 都道府県検索
					} else if (this.pref !== 'すべて') {
						for (let i = 0; i < items.length; i++) {
							if (items[i].prefecture === this.pref) {
								itemsTemp.push(items[i]);
							}
						}
						items = itemsTemp;
					}

					// 県名見出しを作る
					itemsTemp = [];
					let headPref = '';
					for (let i = 0; i < items.length; i++) {
						if (items[i].prefecture !== headPref) { // 初出の都道府県を見出しにする
							itemsTemp.push({ prefhead: items[i].prefecture });
							headPref = items[i].prefecture;
						}
						itemsTemp.push(items[i]);
					}
					items = itemsTemp;

					// 0件の場合
					if (items.length === 0) {
						items.push({ noItem: true });
					}

					return (items);
				}
			},
			mounted() {
				// 都道府県プルダウン発火
				let $selectPref = $('#selectPref');
				$selectPref.find('.mod-dropdown-top').on('click', (e) => {
					if (!$(e.currentTarget).closest('#selectPref').hasClass(a)) {
						$selectPref.removeClass(a);
						$(e.currentTarget).closest('#selectPref').addClass(a);
					} else {
						$(e.currentTarget).closest('#selectPref').removeClass(a);
					}
				});
				$(document).on('click', (e) => {
					if ($selectPref.hasClass(a)) { $(ele).removeClass(a); }
				});

				$('.donation-facilities-list a').matchHeight();

				this.$nextTick(() => {
					$('.mod-loader').removeClass(l);
					setTimeout(() => { $('#vue-app').addClass(v); }, 200);
				})
			},
			updated() {
				$('.mod-loader').addClass(l);
				$('#vue-app').removeClass(v);

				if ($('.donation-facilities-list a').length === 1) {
					$('.donation-facilities-list a').css('height', 'auto');
				} else {
					$('.donation-facilities-list a').matchHeight();
				}

				if (this.keyword) {
					history.replaceState('', TITLE, PATH + `?p_keyword=${this.keyword}`);
				} else if (this.pref !== 'すべて') {
					history.replaceState('', TITLE, PATH + `?p_prefectures=${this.pref}`);
				} else {
					history.replaceState('', TITLE, PATH);
				}

				let scrollPos = $('.reg-reception-form').offset().top;
				if (FUNCTIONS.va.window.width < FUNCTIONS.va.device.sp) {
					scrollPos -= FUNCTIONS.va.header.sp;
				} else {
					scrollPos -= FUNCTIONS.va.header.desktop;
				}
				$('html, body').stop().animate({ scrollTop: scrollPos }, 600, 'easeOutExpo');

				setTimeout(() => {
					$('.mod-loader').removeClass(l);
					$('#vue-app').addClass(v);
				}, 200);
			}
		}).mount('#vue-app');

	};

})(window.jQuery, window.FUNCTIONS);
